import { request } from '@/axios';

const normalizeVerifyCode = (code: unknown) => String(code ?? '').replace(/\s+/g, '');

interface Login {
  account: string;
  code: string | number;
  loginType: number; // 1: 验证码 2: 密码
  password: string;
  source: string;
  inviteCode?: string;
  anonymousId: string;
  recommendUniqueId: string; // 推荐人用户唯一id
  recommendModelId: string; // 推荐人模型id
  accountId?: string;
  channel?: number;
  platformCode?: number;
  url?: string;
}
export interface LoginResponse {
  account: string;
  avatar: string;
  firstLogin: boolean;
  id: string;
  nickname: string;
  token: string;
  uniqueId: string;
  isInner: boolean | null;
  source: string;
  paid: boolean;
  hasPassword: boolean;
  isWechat: boolean;
  email: string;
  abtest: string;
  inviteCode: string;
  teamId?: number;
  superAdmin?: boolean;
  teamName?: string;
  teamNickname?: string;
  /** 是否当前用户是团队版 */
  curTeam?: boolean; 
  /** 年费会员，一年送2个月的专属abtest */
  teamMemberAbtest?: boolean; 
  /** 是否为波克用户 */
  hasCompany?: boolean;
  /** 用户创建时间，格式：YYYY-MM-DD HH:mm:ss */
  ctime?: string; 
  /** 用户类型，q1是新队列，q2是旧队列 */
  qtest?: string; 
  /** 是否开启支付宝自动扣费 */
  isAlipaySign: boolean;
  /**
   * 水印/认证状态 (0-5)
   * 随 userInfo 接口一起返回，替代旧的独立 certFyResult API
   * @see WatermarkStatusEnum
   */
  realizeResult?: number;
  /** 是否走 Klein 工作流 V2（智能扩图 modelId=50、智能编辑 modelId=51 等） */
  /**
   * 是否使用新版一键成稿流程（全面增强三合一功能）
   * true: 新版，使用全面增强开关
   * false/undefined: 旧版，使用三个独立开关
   */
  goWorkFlowV2?: boolean;
  /** 团队模型限制黑名单（moduleTypeId 数组），空数组 = 无限制 */
  moduleLimits?: number[];
  /** 是否为 QPS 白名单用户（享受增强并发数） */
  qpsEnabled?: boolean;
}
export function login(data: Login) {
  const safeData = {
    ...data,
    code: normalizeVerifyCode(data.code),
  };
  return request<LoginResponse>({
    api: '/user/login',
    method: 'post',
    data: safeData,
    // notToast: true
  });
}

export function logout() {
  return request({
    api: '/api/user/logout',
    method: 'get',
  });
}


interface ValidatePhoneNumber {
  account: string;
  code: string;
  email: string;
}
export function validatePhoneNumber(data: ValidatePhoneNumber) {
  const safeData = {
    ...data,
    code: normalizeVerifyCode(data.code),
  };
  return request({
    api: '/user/verifyCode',
    method: 'post',
    data: safeData
  });
}

interface ResetPassword {
  account: string;
  password: string;
  email: string;
}
export function resetPassword(data: ResetPassword) {
  return request({
    api: '/user/restPassword',
    method: 'post',
    data
  });
}

// 获取微信登录二维码
export function getWeChatLoginQRCode(data: {
  event: 'login' | 'banding' | 'unBanding';
  source: string;
  distinctId: string;
  url: string;
}) {
  return request<{
    ticket: string;
    url: string;
  }>({
    api: '/wechatOfficialAccount/getQrCodeByLogin',
    method: 'post',
    data,
  });
}

// 获取微信登录扫码结果
export function getWeChatLoginQRCodeStatus(data: {
  ticket: string;
}) {
  return request<{
    eventStatus: string;
    expiredTime: string;
    openId: string;
    unionId: string;
  }>({
    api: '/wechatOfficialAccount/getLoginResultByCircle',
    method: 'post',
    data,
    notToast: true,
  });
}

// 检测手机号是否注册
export function checkAccountExist(data: {
  account?: string;
  email?: string;
}) {
  return request<{
    account: string;
    email: string;
    isExist: boolean;
  }>({
    api: '/user/checkAccountExist',
    method: 'post',
    data,
    notToast: true,
  });
}

// 获取埋点source
export function getEvenSource(data: Record<'platformCode' | 'source', any>) {
  return request<{ source: string }>({
    api: '/user/getSource',
    method: 'post',
    data,
  });
}
